// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1advO","header":"PatientQuestionnaire_header__2P5gC","info":"PatientQuestionnaire_info__166wN"};